import React__default from 'react';

const ThemeContext = /*#__PURE__*/React__default.createContext({
  // Any theme related props needed? Put them in here
});

export { ThemeContext as T };
